import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { WidgetData } from '@/components/Dashboard/Widgets/types/Widget';

@Component({})
export default class WidgetHeader extends Vue {

    @Prop()
    private widgetInstance!: WidgetData

    private showConfigModal = false
    private title = ''

    created(): void {
        this.title = this.widgetInstance.title
    }

    @Emit('onRefresh')
    onRefresh(): boolean {
        return true
    }

    @Emit('openConfig')
    openConfig(): boolean {
        return true
    }

    updateInstance(widgetData: WidgetData): void {
        this.title = widgetData.title
    }
}